import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Project} from 'src/app/models/project.model';
import {AdminService} from 'src/app/services/admin.service';
import {ProjectService} from 'src/app/services/project.service';
import {environment} from 'src/environments/environment';
import {ProjectCategoryService} from 'src/app/services/project-category.service';
import {Subscription} from 'rxjs';
import {ProjectCategory} from 'src/app/models/project-category.model';

@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.css'],
})
export class ProjectDetailsComponent {
  project: Project;
  apiUrl = environment.apiUrl;
  categorySubscription$: Subscription;
  categories: ProjectCategory[] = [];
  image =
    'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg';

  showSpinner: boolean = true;
  validSponsorImages: string[] = [];
  validPartnerImages: string[] = [];

  constructor(
    private readonly projectService: ProjectService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly adminService: AdminService,
    private readonly categoryService: ProjectCategoryService
  ) {
  }

  ngOnInit(): void {
    this.categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ =
      this.categoryService.projectCategorySubject$.subscribe(
        (response: ProjectCategory[]) => {
          // console.log("--------------------------------------------")
          this.categories = response;
        },
        (error) => {
          console.log('An error occured: ' + error);
        }
      );

    const id = +this.route.snapshot.params['id'];
    this.projectService.getProject(id).subscribe((response) => {
      let category_name = this.categories.find(
        (cat: any) => cat.id.toString() === response.category_id?.toString()
      );

      this.project = response;
      console.log('The project', this.project);

      this.showSpinner = false;

      this.project.sponsor_images_url = this.convertStringToArray(
        this.project.sponsor_images_url
      );

      this.project.partners_images_url = this.convertStringToArray(
        this.project.partners_images_url
      );

      // Filter out placeholder and empty images
      this.validSponsorImages = this.project.sponsor_images_url ?
        this.project.sponsor_images_url.filter(url => url && url !== '' && url !== this.image) : [];

      this.validPartnerImages = this.project.partners_images_url ?
        this.project.partners_images_url.filter(url => url && url !== '' && url !== this.image) : [];
    });
  }

  isAdmin() {
    return this.adminService.isLoggedIn();
  }

  editProject() {
    this.router.navigateByUrl(`/projects/${this.project.id}/edit`);
  }

  deleteProject(project: Project) {
    this.projectService.deleteProject(project.id ?? 0).subscribe((response) => {
      this.projectService.emitProjectSubject();
      this.router.navigate(['/projects/list']);
    });
  }

  // carry this code into a helper service later
  convertStringToArray(inputString: any) {
    const trimmedString = inputString.trim();

    // console.log("---", inputString)
    // console.log("---", trimmedString)
    // Check if the string starts and ends with square brackets
    if (trimmedString.startsWith('[') && trimmedString.endsWith(']')) {
      // Remove the square brackets
      const stringWithoutBrackets = trimmedString.slice(1, -1);

      // Split the remaining string by commas
      const stringArray = stringWithoutBrackets.split(',');

      // Trim and wrap each element in single quotes
      const resultArray = stringArray.map(
        (element: any) => `${element.trim().slice(1, -1)}`
      );

      return resultArray;
    } else {
      console.error('Input is not in the expected format.');
      return [];
    }
  }
}
